/* global Office, console, Word, Excel */

import PlatformType = Office.PlatformType;

function mergeAllSlices(slices: any[]) {
  let data = [];
  const numberSlices = slices.length;
  for (let i = 0; i < numberSlices; i++) {
    data = data.concat(slices[i]);
  }
  return new Uint8Array(data);
}

const fileContentToBlob = (content: any) => {
  return new Blob([content], { type: "application/pdf" });
};

export async function getDocumentName(): Promise<String> {
  const documentUrl = new URL(Office.context.document.url);
  const documentPath = decodeURIComponent(documentUrl.pathname);
  return documentPath.replace(/^.*[\\\/]/, '');
}

async function closeFile(state) {
  try {
    await state.file.closeAsync(result => console.log(result));
    console.log("File closed successfully");
  } catch (error) {
    console.error("Error: File couldn't be closed", error);
  }
}

async function sendSlice(slice, state) {
  const data = slice.data;
  const counter = state.counter;
  if (data) {
    state.fileDataSlices[counter] = data;
    state.counter++;
    if (state.counter < state.sliceCount) {
      getSlice(state);
    } else {
      // All slices are ready to submit
      const fileData = mergeAllSlices(state.fileDataSlices);
      const fileAsBlob = fileContentToBlob(fileData);
      const fileName = await getDocumentName();
      state.handleSendFile(fileAsBlob, fileName);
      closeFile(state);
    }
  }
  return null;
}

function getSlice(state) {
  state.file.getSliceAsync(state.counter, (result) => {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      sendSlice(result.value, state);
    }
  });
}

function getDocAsCompressed(handleSendFile: (blob: Blob, fileName: string, platform: PlatformType) => void) {
  Office.context.document.getFileAsync(
    Office.FileType.Pdf,
    { sliceSize: 65000 }, // 65536 is maximum on MacOS
    (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        // Get File object from result
        const myFile = result.value;
        const state = {
          file: myFile,
          counter: 0,
          sliceCount: myFile.sliceCount,
          fileDataSlices: [],
          handleSendFile,
        };
        getSlice(state);
      } else {
        console.log("couldn't compress ", result.status);
      }
    }
  );
}

export async function getWordFile(handleSendFile: (blob: Blob, fileName: string, platform: PlatformType) => void) {
  Word.run((context) => {
    const thisDocument = context.document;
    context.load(thisDocument, "saved");
    // @ts-ignore
    return context.sync().then(() => {
      if (!thisDocument.saved) {
        // Save document changes before uploading the file into sofa
        thisDocument.save();
        return context.sync().then(() => {
          getDocAsCompressed(handleSendFile);
        });
      } else {
        getDocAsCompressed(handleSendFile);
      }
    });
  }).catch((error) => console.log("Error: ", JSON.stringify(error)));
}

export async function getExcelFile(handleSendFile: (blob: Blob, fileName: string, platform: PlatformType) => void) {
  Excel.run((context) => {
    const thisDocument = context.workbook;
    context.load(thisDocument, "saved");
    // @ts-ignore
    return context.sync().then(() => {
      // Save document changes before uploading the file into sofa
      thisDocument.save(Excel.SaveBehavior.save);
      return context.sync().then(() => {
        getDocAsCompressed(handleSendFile);
      });
    });
  }).catch((error) => console.log("Error: ", JSON.stringify(error)));
}
